const cacheStore = new Map();

export const BOOKINGS_CACHE_TTL_MS = 60 * 1000;

export function getCacheKey(params) {
    return JSON.stringify(params);
}

export function getCachedBookings(key) {
    const cached = cacheStore.get(key);
    if (!cached) {
        return null;
    }

    if (cached.expiresAt < Date.now()) {
        cacheStore.delete(key);
        return null;
    }

    return cached.value;
}

export function setCachedBookings(key, value, ttl = BOOKINGS_CACHE_TTL_MS) {
    cacheStore.set(key, {
        value,
        expiresAt: Date.now() + ttl,
    });
}

export function patchCachedBookingsStatus(bookingId, status) {
    cacheStore.forEach((entry, key) => {
        if (!entry?.value?.results) {
            return;
        }

        const patchedResults = entry.value.results.map((row) => (
            row.id === bookingId ? {...row, status} : row
        ));

        cacheStore.set(key, {
            ...entry,
            value: {
                ...entry.value,
                results: patchedResults,
            }
        });
    });
}
